// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","455":"4f480817","977":"255b6566"}[chunkId] + ".chunk.js";
};